
<template>
<div>
  <div style="width: 90%;margin: auto;">
    <p class="stepTitle">活动信息</p>
    <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动名称：" prop="Title">
            <el-input width="100%" v-model="ruleForm.Title" placeholder="请输入活动名称（5-30个字）"
              maxlength="30" minlength="5" :disabled="(setType==2 || setType==3)?true:false"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动时间：" prop="value1">
            <el-date-picker type="daterange" v-model="value1" @change="changeActiveTime"
              value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptionsStart" :disabled="(setType==2 || setType==3)?true:false"
              style="width:100%;cursor:pointer;background:#fff;border:1px solid #eee;"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="whichRole" label="所在城市：" prop="chengshi" style="width: 50%" v-show="!newLmhd">
        <el-cascader placeholder="请选择城市" :options="options" style="width: 100%" filterable clearable
          v-model="chengshi" :disabled="(setType==2 || setType==3)?true:false" @change="handleChange"/>
      </el-form-item>
      <!-- <el-form-item label="活动地点：" prop="Address">
        <el-input type="text" v-model="ruleForm.Address" :disabled="(setType==2 || setType==3)?true:false" placeholder="请输入活动地点" maxlength="50"/>
      </el-form-item> -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动Banner：" prop="bannerImgUrl" class="uploadActiveForm">
            <div class="uploadActive">
              <el-upload v-show="isdisabled" class="avatar-uploader activeUploadImg"
                style action :show-file-list="false" :disabled="(setType==2 || setType==3)?true:false"
                :before-upload="(file)=>beforeAvatarUpload(file, 1)">
                <div class="bannerImgUrl" v-if="bannerImgUrl">
                  <img :src="bannerImgUrl" style="width: 165px; height: 80px"/>
                </div>
                <div v-if="!bannerImgUrl" class="bannerImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;line-height: 10px;"> 建议尺寸：1200*675，支持的图片格式：jpg、png。 </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分享封面：" prop="fxfmImgUrl" class="uploadActiveForm">
            <div class="uploadActive">
              <el-upload v-show="isdisabled" class="avatar-uploader activeUploadImg"
                style action :show-file-list="false" :disabled="(setType==2 || setType==3)?true:false"
                :before-upload="(file)=>beforeAvatarUpload(file, 2)">
                <div class="fxfmImgUrl" v-if="fxfmImgUrl">
                  <img :src="fxfmImgUrl" style="width: 165px; height: 80px"/>
                </div>
                <div v-if="!fxfmImgUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;line-height: 10px;"> 封面图片尺寸比例要求为:1000*800，支持的图片格式：jpg、png；最大不超过5MB。</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="活动类型：" prop="region">
        <el-table :data="ActivityFormRelationDTOs" stripe border style="height: auto">
          <el-table-column label="活动类型" align="center">
            <template scope="scope">
              <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                :title="scope.row.ActivityFormName">{{ scope.row.ActivityFormName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="活动标题" align="center">
            <template scope="scope">
              <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                :title="scope.Title">{{ scope.row.Title }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" v-if="(setType==2 || setType==3)?false:true">
            <template slot="header">
              <span @click="addActiveTypeDiaShow" style="color: #6786b4; cursor: pointer">新增活动类型</span>
            </template>
            <template scope="scope">
              <span style="color: #6786b4; margin-left: 8px; cursor: pointer"
                @click="deleteActiveType(scope)"> <i class="el-icon-delete"></i> 删除
              </span>
              <!-- <span style="color: #6786b4; margin-left: 8px; cursor: pointer"
                @click="spUpordown(1, scope)"> <i class="el-icon-upload2"></i> 向上
              </span>
              <span style="color: #6786b4; margin-left: 8px; cursor: pointer"
                @click="spUpordown(2, scope)"> <i class="el-icon-download"></i> 向下
              </span> -->
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <!-- <el-form-item label="直播视频(选填)：">
        <el-input v-model.trim="ruleForm.zbsp" placeholder="请输入直播房间号码" maxlength="10" style="width: 44.5%"/> <span style="color: #6786b4; margin-left: 8px;">温馨提示：房间号码请联系平台工作人员，电话：17611428173</span>
      </el-form-item> -->
      <!-- <el-form-item label="活动亮点：" prop="HighlightOne" style="width: 50%">
        <el-input type="text"
          v-model="ruleForm.HighlightOne" :disabled="(setType==2 || setType==3)?true:false"
          placeholder="请输入活动亮点（10字以内）"
          maxlength="10"/>
      </el-form-item>
      <el-form-item label="" prop="HighlightTwo" style="width: 50%">
        <el-input type="text"
          v-model="ruleForm.HighlightTwo" :disabled="(setType==2 || setType==3)?true:false"
          placeholder="请输入活动亮点（10字以内）"
          maxlength="10"/>
      </el-form-item>
      <el-form-item label="" prop="HighlightThree" style="width: 50%">
        <el-input type="text"
          v-model="ruleForm.HighlightThree" :disabled="(setType==2 || setType==3)?true:false"
          placeholder="请输入活动亮点（10字以内）"
          maxlength="10"/>
      </el-form-item> -->
      <!-- <el-form-item label="颜色主题：">
        <div class="yszt">
          <dl v-for="(item, index) in ysztList" :key="index" @click="colorChange(item,index)" style="position: relative;">
            <dt>
              <div :class="item.dDicId == ruleForm.ColorThemeId?'blackMask':''">
                <i class="el-icon-success" :class="item.dDicId == ruleForm.ColorThemeId?'blackysztmc':'blackysztmcnone'"/>
              </div>
              <img :src="item.dDicIcon_FullPath"/>
            </dt>
            <dd @click="seeLarge(item.dDicIcon_FullPath, item.remark)">查看大图</dd>
          </dl>
        </div>
      </el-form-item> -->
      <el-form-item label="小标题（选填）：">
        <el-form v-for="(item,index) in journalArr" :key="index">
          <el-form-item style="width:50%">
            <el-input type="text" v-model="item.title" placeholder="请输入小标题（10字以内）" maxlength="10" :disabled="(setType==2 || setType==3)?true:false"/>
            <el-button type="warning" @click="shanchu(index)" class="shanBtn" v-show="index > 0"><i class="el-icon-delete"/> 刪除</el-button>
          </el-form-item>
          <div class="upPictures">
            <div class="multigraph" v-for="(img,index) in item.images" :key="index" :data-img="img">
              <el-image style="width: 100px; height:100px" :src="img"/>
              <div class="chahao" @click.stop="deldetail(item, index)" v-show="(setType==2 || setType==3)?false:true">
                <img src="../../assets/img/aicon36.png"/>
              </div>
            </div>
            <!-- 上传图片 -->
            <el-upload action multiple v-if="item.images.length < 10" accept=".png, .jpg,.jpeg"
            :limit="10" :before-upload="(file)=>multiGraphUpload(file, item)" v-show="(setType==2 || setType==3)?false:true">
              <i class="el-icon-plus upBtn"></i>
            </el-upload>
          </div>
          <div style="color:#888;">建议宽为1200像素，高不限，支持的图片格式：jpg、png。最大不超过5MB，最多支持上传10张。</div>
        </el-form>
        <div class="primarybtn" v-if="journalArr.length < 10" v-show="(setType==2 || setType==3)?false:true">
          <el-button type="primary" @click="addJournal()"><i class="el-icon-plus"/> 再增加一条</el-button>
        </div>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" class="search_btn" @click="toNextStep('ruleForm')">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
  <!-- 新增活动类型 -->
  <el-dialog width="30%" title="新增活动类型" class="IdenticalPadding"
    :before-close="cancelActiveType" :visible.sync="addInnerVisible"
    :modal-append-to-body="false" :modal="true">
    <el-form :model="addActiveTypeForm" width="30%" class="eleWidthInput" ref="addActiveTypeForm">
      <el-form-item label="活动类型：" :label-width="formLabelWidth">
        <el-select v-model="addActiveTypeForm.typeId" placeholder="请选择活动类型" @change="changeActivityForm">
          <el-option v-for="(item, index) in newActivityFormList" :key="index" :value="item.Id" :label="item.Name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="活动标题：" :label-width="formLabelWidth">
        <el-input v-model.trim="addActiveTypeForm.name" placeholder="请输入活动标题" maxlength="10"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelActiveType">取 消</el-button>
      <el-button type="primary" class="search_btn"
        style="margin-left: 20px" @click="endAddActiveType">新增</el-button>
    </div>
  </el-dialog>
  <!-- 查看大图 -->
  <el-dialog :visible.sync="isShowYszt" @closed="clearImg" title='查看大图'>
    <div class="imgDialog slither">
      <!-- <img style="width:auto; height:auto; max-width:100%; max-height:100%;" :src="showImageUrl"/> -->
      <img style="width:auto; height:auto; max-width:30%;" :src="showImageUrl"/>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, oneGetProvinceAndCityList, datadictionaryGetlist } from '../../api/newOss';
import { getCreateActive, getSelectActiveForm, getInsertActiveForm, getActiveFormOrde, getDeleteActiveForm,
  getUpdateActiveBasicInfo, getSelectActiveBasicInfo, getInsertActiveBasicInfo } from "../../api/addActiviteForm";
export default {
  name: "oneStep",
  data() {
    return {
      isdisabled: true,
      value1: "", // 活动时间
      chengshi: "", // 所在城市
      bannerImgUrl: "", // 活动banner
      fxfmImgUrl: '', // 分享封面
      addActiveTypeForm: {
        typeId: "",
        typeName: "", // 活动类型name
        name: "",
      },
      formLabelWidth: "80px",
      ruleForm: {
        Title: "", // 活动名称
        ProvinceId: 0, // 省
        CityId: 0, // 市
        BannerUrl: "",
        ShareCoverImg: '',
        ActivityBrandImg: '', // 参展品牌
        zbsp: '', // 直播视频
        HighlightOne: "",
        HighlightTwo: "",
        HighlightThree: "",
        Address: "",
        temporaryId: "", // 临时id
        ColorThemeId: 1, // 颜色主题 int
      },
      ActivityFormRelationDTOs: [], // 活动类型列表
      addInnerVisible: false, // 新增活动弹框
      newActivityFormList: [], // 新增活动类型列表

      options: [],
      tbdprovince: [], // 省
      tbdcity: [], // 市

      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      setType: "", // 类型 判断是编辑还是查看
      newLmhd: '',
      timeInterval: [], // 时间区间集合
      ysztList: [], // 颜色主题集合
      isShowYszt: false,
      showImageUrl: '', // 大图预览
      shopId: '', // 店铺活动-店铺id
      journalArr: [{title: '', images: []}], // 日志集合
    };
  },
  props:{
    whichRole:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    // 初始化
    initComponent(val, type, lmhd, shopId) {
      this.getprovince(); // 所在城市
      this.setType = type;
      this.shopId = shopId; // 店铺活动-店铺id
      if(Array.isArray(lmhd)) {
        this.newLmhd = localStorage.getItem("lianmengId")
      } else {
        this.newLmhd = lmhd; // 联盟活动
      }
      if(val){
        this.ruleForm.temporaryId = val;
      }
      // 新增
      if(!this.setType) {
        this.getTemporary();
      }
      // 编辑
      if(this.setType == 1) {
        // 走查看回显接口
        this.echoData(val);
      }
      // 查看
      if(this.setType == 2 || this.setType == 3) {
        // 走查看回显接口 同时并禁用
        this.echoData(val);
      }
    },
    // 新增活动时 1-生成临时活动id
    getTemporary() {
      var obj = {};
      getCreateActive(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.ruleForm.temporaryId = data.ResultObj;
        }
      });
    },
    // 查看回显接口
    echoData(temporaryId){
      var obj = {
        activeId: temporaryId // 活动id
      };
      getSelectActiveBasicInfo(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.ruleForm = data.ResultObj;
          this.ruleForm.temporaryId = temporaryId; // 活动id
          this.bannerImgUrl = localStorage.BaseOssUrl + data.ResultObj.BannerUrl; // 活动banner
          this.fxfmImgUrl = localStorage.BaseOssUrl + data.ResultObj.ShareCoverImg; // 分享封面
          this.value1 = [this.ruleForm.StartTime,this.ruleForm.EndTime];
          this.chengshi = [this.ruleForm.ProvinceId,this.ruleForm.CityId];
          this.ActivityFormRelationDTOs=this.ruleForm.ActivityFormRelationDTOs;
          // 小标题集合
          let subheading = this.ruleForm.Images.length>0?this.ruleForm.Images:[{title: '', images: []}]; // 小标题集合
          subheading = subheading.map(item => {
            item.images = item.images.map(img => {
              return img.replace('', localStorage.BaseOssUrl)
            })
            return item
          })
          this.journalArr = subheading // 小标题集合
        }
      });
    },
    // 触发新增活动类型弹框 & 并查询活动类型列表
    addActiveTypeDiaShow(){
      this.addInnerVisible = true;
      this.addActiveTypeForm = {};
      var obj = {
        operatorId: localStorage.Id, // 操作人用户id
        activeId: this.ruleForm.temporaryId, // 活动id
        sponsorType: this.newLmhd?4:1, // 活动类型、1=平台活动、4=联盟活动
        shopId: this.shopId, // 店铺活动-店铺id
      };
      getSelectActiveForm(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.newActivityFormList = data.ResultObj;
        }
        if (data.ResultCode == 4) {
          this.newActivityFormList = [];
        }
      });
    },
    // 获取活动类型Name
    changeActivityForm(val){
      this.newActivityFormList.filter((item,index) => {
        if(item.Id == val){
          this.addActiveTypeForm.typeName = item.Name;
        }
      })
    },
    // 新增活动类型按钮
    endAddActiveType() {
      // 验证活动类型
      if (!this.addActiveTypeForm.typeId) {
        this.$swal({
          type: "warning",
          text: "请选择活动类型",
        });
        return false;
      }
      // 验证活动标题
      if (!this.addActiveTypeForm.name) {
        this.$swal({
          type: "warning",
          text: "请输入活动标题",
        });
        return false;
      }
      // 提交表单
      var obj = {
        ActivityId: this.ruleForm.temporaryId, // 活动临时id
        ActivityFormId: this.addActiveTypeForm.typeId, // 活动类型id
        ActivityFormName: this.addActiveTypeForm.typeName, // 活动类型名称
        Title: this.addActiveTypeForm.name, // 标题
      };
      getInsertActiveForm(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.addInnerVisible = false;
          this.ActivityFormRelationDTOs=data.ResultObj;
        }
      });
    },
    // 取消新增活动类型
    cancelActiveType() {
      this.addInnerVisible = false;
      this.addActiveTypeForm = {};
    },
    // 活动时间转换
    changeActiveTime(time) {
      this.ruleForm.StartTime = time[0];
      this.ruleForm.EndTime = time[1];
      
      let arr = []
      let str_b = time[0].split('-')
      let str_e = time[1].split('-')
      let date_b = new Date()
      date_b.setUTCFullYear(str_b[0], str_b[1] - 1, str_b[2])
      let date_e = new Date()
      date_e.setUTCFullYear(str_e[0], str_e[1] - 1, str_e[2])
      let unixDb = date_b.getTime() - 24 * 60 * 60 * 1000
      let unixDe = date_e.getTime() - 24 * 60 * 60 * 1000
      for (let j = unixDb; j <= unixDe;) {
        j = j + 24 * 60 * 60 * 1000
        arr.push(this.timestampToTime(new Date(parseInt(j))))
      }
      console.log(arr);
      this.timeInterval = arr; // 时间区间集合
      // this.$cookie.set("timeInterval", this.timeInterval); // 时间段集合 存入cookie
      localStorage.setItem('timeInterval',JSON.stringify(this.timeInterval));
    },
    // 获取时间段函数
    timestampToTime (date) {
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate();
      return Y + M + D;
    },
    //  清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancleAddBaseMsg')
    },
    // 点击进入第二部
    toNextStep() {
      if (!this.ruleForm.Title) {
        this.$swal({
          type: "warning",
          text: "请输入活动名称",
        });
        return false;
      }
      if (this.ruleForm.Title.length < 5) {
        this.$swal({
          type: "warning",
          text: "活动名称最少5个字",
        });
        return false;
      }
      if (!this.value1) {
        this.$swal({
          type: "warning",
          text: "请选择活动时间",
        });
        return false;
      }
      // if (!this.ActivityFormRelationDTOs.length) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请添加活动类型",
      //   });
      //   return false;
      // }
      if (this.whichRole) {
        if(!this.newLmhd) {
          if(!this.chengshi){
            this.$swal({
              type: "warning",
              text: "请选择所在城市",
            });
            return false;
          }
        }
      }
      // if (!this.ruleForm.Address) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入活动地点",
      //   });
      //   return false;
      // }
      if (!this.bannerImgUrl) {
        this.$swal({
          type: "warning",
          text: "请上传活动banner",
        });
        return false;
      }
      if(!this.fxfmImgUrl) {
        this.$swal({
          type: "warning",
          text: "请上传分享封面",
        });
        return false;
      }
      // 暂存时间
      localStorage.setItem('StartTime',this.ruleForm.StartTime);
      localStorage.setItem('EndTime',this.ruleForm.EndTime);
      
      let xbtArr = this.journalArr.find(item => item.title && item.images.length===0)
      if (xbtArr){
        this.$swal({
          type:"warning",
          text: '请至少上传一张' + xbtArr.title + '标题的图片'
        })
        return false;
      }
      // 小标题
      let journalData = []
      this.journalArr.map(item => {
        let the = {
          "ImageType": 1,
          "ImageUrl": "",
          "Remark": item.title,
          "Sort": 0
        }
        item.images.map(img => {
          let the2 = JSON.parse(JSON.stringify(the))
          the2.ImageUrl = img.replace( localStorage.BaseOssUrl, '')
          journalData.push(the2)
        })
      })
      let params={
        OperatorId: localStorage.Id,
        ActivityId: this.ruleForm.temporaryId,
        SponsorType: this.newLmhd?4:0, // 活动类型   4=联盟活动
        MAid: this.newLmhd?this.newLmhd:0, // 联盟id
        shopId: this.shopId, // 店铺活动-店铺id
        ImageList: journalData, // 小标题
        ...this.ruleForm
      }
      // 新增
      if(!this.setType){
        getInsertActiveBasicInfo(params).then((data) => {
          if (data.ResultCode == 1) {
            let editActivityId = data.ResultObj;
            let sponsorType = data.RowsCount;
            this.$emit('toNextStep',!this.whichRole || this.newLmhd ? 2 : 1,editActivityId, this.ActivityFormRelationDTOs,sponsorType);
          }
        });
      }
      // 修改
      if(this.setType == 1){
        getUpdateActiveBasicInfo(params).then((data) => {
          if (data.ResultCode == 1) {
            let sponsorType = data.RowsCount;
            this.$emit('toNextStep',!this.whichRole || this.newLmhd ? 2 : 1,this.ruleForm.temporaryId, this.ActivityFormRelationDTOs, sponsorType);
          }
        });
      }
      // 查看
      if(this.setType == 2 || this.setType == 3){
        this.$emit('toNextStep',!this.whichRole || this.newLmhd ? 2 : 1,this.ruleForm.temporaryId,this.ActivityFormRelationDTOs);
      }
    },
    // 活动Banner & 分享封面
    beforeAvatarUpload(file, type) {
      const isSize = new Promise(function (resolve, reject) {
        let width = type == 1 ? 1200 : 1000;
        let height = type == 1 ? 675 : 800;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function (e) {
            var obj = { type: 11 };
            getOssFile(obj).then(data => {
              if (data.resultCode == 1) {
                let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
                let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
                let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
                let ossfile = data.resultObj.directory; // 保存路径
                let ossbucket = data.resultObj.bucket; // bucket
                localStorage.setItem('keyossId',ossId);
                localStorage.setItem('keyossSecret',ossSecret);
                localStorage.setItem('keyossHost',ossHost);
                localStorage.setItem('keyossfile',ossfile);
                localStorage.setItem('keyossbucket',ossbucket);
              }
            })
            var newOssPic = await uploadOSS(file,0);
            if(type == 1) {
              that.bannerImgUrl = newOssPic;
              that.ruleForm.BannerUrl = newOssPic.replace(localStorage.BaseOssUrl,'')
            }
            if(type == 2) {
              that.fxfmImgUrl = newOssPic;
              that.ruleForm.ShareCoverImg = newOssPic.replace(localStorage.BaseOssUrl,'')
            }
          };
          return file;
      },() => {
        this.$swal({
          type: "warning",
          text: type == 1?"上传图片宽高应为1200*675":"上传图片宽高应为1000*800",
        });
        return Promise.reject();
      });
      return isSize;
    },

    // 活动类型 操作:向上/向下
    spUpordown(val, scope) {
      var obj = {
        activeId: scope.row.ActivityId, // 临时活动id
        activeFormId: scope.row.ActivityFormId, // 活动类型id
        direction: val, // 类型 1：向上、2：向下
      };
      getActiveFormOrde(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.ActivityFormRelationDTOs = data.ResultObj;
        }
      });


    },
    // 删除活动类型
    deleteActiveType(scope) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除当前活动类型吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          //点击了确定后返回的为true
          var obj = {
            activeId: scope.row.ActivityId, // 临时活动id
            activeFormId: scope.row.ActivityFormId, // 活动类型id
          }
          getDeleteActiveForm(obj).then(data=>{
            if(data.ResultCode == 1){
              this.ActivityFormRelationDTOs = data.ResultObj;
            }
            if(data.ResultCode == 4){
              this.ActivityFormRelationDTOs = [];
            }
          })
        }
      });
    },
    // 设置颜色主题-选中样式
    colorChange(item, index) {
      this.ruleForm.ColorThemeId = item.dDicId; // 获取对应id
    },
    // 颜色主题
    seeLarge(valImg, bigImg) {
      this.showDialog(bigImg);
    },
    // 查看图片
    showDialog(itemImg) {
      this.showImageUrl = itemImg;
      this.isShowYszt = true;
    },
    // 关闭查看大图
    clearImg(){
      this.isShowYszt = false;
    },
    // 请选择省市
    handleChange(val) {
      this.ruleForm.ProvinceId = val[0]; // 省
      this.ruleForm.CityId = val[1]; // 市
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isOpen: 1,
        userId: localStorage.Id
      };
      oneGetProvinceAndCityList(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 省
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name};
            provinceData.children.push(cityData);
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
    // 获取颜色主题
    colorTheme() {
      let obj = {
        code: 'activity_color_theme',
      }
      datadictionaryGetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.ysztList = data.resultObj;
        }
        if(data.resultCode == 4){
          this.ysztList = [];
        }
      })
    },
    // 增加日志
    addJournal() {
      this.journalArr.push({title: '', images: []})
    },
    // 刪除日志
    shanchu(index) {
      this.journalArr.splice(index, 1);
    },
    // 多图上传
    multiGraphUpload(file, item) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      if (item.imgsLength) {
        item.imgsLength = item.imgsLength + 1
      } else {
        item.imgsLength = 1
      }
      if (item.imgsLength <= 10) {} else {
        this.$swal({
          type: "warning",
          text: "最多传入10张图片"
        });
        return false;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        // oss 直传图片
        var obj = {
          type: 11
        };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
          }
        })
        var newOssPic = await uploadOSS(file,0);
        item.images.push(newOssPic);
        
      };
      return file;
    },
    // 删除上传图片
    deldetail(item, index) {
      item.images.splice(index, 1)
      item.imgsLength = item.images.length
    },
  },
  mounted(){
    this.colorTheme(); // 初始化获取颜色主题
  },

};
</script>

<style scoped>
/* 颜色主题 */
.yszt {
  width: 90%;
  height: 200px;
  display: flex;
}
.yszt dl {
  margin-right: 10px;
  cursor: pointer;
}
.yszt dl dt img {
  width: 150px;
  height: 150px;
  border-radius: 5px;
}
.yszt dl dd {
  font-weight: bold;
  color: #409EFF;
}
/* 查看大图-滑动 */
.slither {
  height: 600px;
  text-align: center;
  overflow: scroll;
}
/* 颜色主题-选中蒙层效果 */
.blackMask {
  width: 150px;
  height: 150px;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background:rgba(0,0,0,0.5);
}
.blackysztmc {
  position: absolute;
  top: 52px;
  left: 55px;
  font-size: 36px;
  color: #fff;
}
.blackysztmcnone{
  display: none;
}
/* 小标题-集合 */
/* 刪除 */
.shanBtn {
  margin-left: 5px;
  position: absolute;
}
/* 多图 */
.upPictures {
  width: 100%;
  display: flex;
}
.multigraph {
  width: 100px;
  height: 100px;
  position: relative;
  float:left;
  margin: 5px 10px 5px 0;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -5px;
  top: -5px;
  cursor: pointer;
}
.upBtn {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;
  font-size: 26px;
  color: #999;
  margin: 5px 10px 5px 0;
}
/* 再增加一条 */
.primarybtn {
  width: 50%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// oneStep.vue?72a13599